import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DialogsModule } from '../core/dialogs/dialogs.module';
import { routes } from './routes';

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, { enableViewTransitions: true }),
    DialogsModule,
  ],
})
export class PagesModule {}
